import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Input, Button, message, Spin } from 'antd';
import hospital2Image from '../../../images/hospital2.png';
import bingrenNanImage from '../../../images/bingren-nan.png';
import bingrenNvImage from '../../../images/bingren-nv.png';
import styles from '../../styles/accessCode.module.less';
import useDownloadProgress from '../../../../../hooks/useDownloadProgress';
import useStudyData from '../../../../../hooks/useStudyData';
import { utils } from '@ohif/core';
const { apiService } = utils;

function DownloadAccessCode() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const studyUID = queryParams.get('studyUID');
  const code = queryParams.get('code'); // 默认查看码
  const expirationDate = queryParams.get('expirationDate');

  const [inputCode, setInputCode] = useState('');
  const inputRef = useRef(null);
  const [studyLoading, setStudyLoading] = useState(false);
  const register_key = queryParams.get('register_key');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [token, setToken] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const { getDownloadUrl } = useDownloadProgress();
  const tokenManager = (window as any).tokenManager;

  // 解析查询参数为对象
  const initialParams = useMemo(() => {
    const params: { [key: string]: string | number } = {};
    queryParams.forEach((value, key) => {
      if (key !== 'register_key' && key !== 'flag' && key !== 'code' && key !== 'expiration') {
        params[key] = value;
      }
    });
    return params;
  }, [location.search]);

  const { studies, listLoading, getStudyInstanceUid } = useStudyData(initialParams,token);
  // 获取数据
  useEffect(() => {
    const fetchData = async () => {
      if (listLoading) {
        return;
      }

      setLoading(true);
      try {
        if (!register_key) {
          messageApi.error('缺少 register_key 参数，无法加载数据');
          setLoading(false);
          return;
        }

        // 从 studies 中查找匹配的数据
        const studyData = studies.find(item => item.register_key === register_key);
        if (!studyData) {
          setLoading(false);
          return;
        }
        // 合并状态更新
        setData(studyData);
      } catch (error) {
        messageApi.error('加载数据失败，请重试');
      } finally {
        setLoading(false);
      }
    };
    if (tokenManager.getCurrentToken()) {
      fetchData();
    }
  }, [register_key, studies, token]);

  // 处理输入变化
  const handleCodeChange = e => {
    setInputCode(e.target.value);
  };

  const downloadStudy = async studyUID => {
    setStudyLoading(true);
    const url = getDownloadUrl('studies', studyUID, ['dcm']);
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'download';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      setStudyLoading(false);
    } catch (error) {
      setStudyLoading(false);
    }
  };

  // 处理下载提取码
  const handleDownloadOK = useCallback(() => {
    if (!inputCode) {
      messageApi.error('请输入提取码');
      return;
    }
    if (inputCode !== code) {
      messageApi.error('提取码错误');
      return;
    }
    if (!studyUID) {
      messageApi.error('缺少 studyUID 参数，无法下载');
      return;
    }

    apiService({
      uri: `/api/Share/Access?code=${code}`,
      method: 'GET',
      type: null,
    })
      .then(res => {
        if (res.message === '查看码无效或已过期。') {
          messageApi.error('查看码无效或已过期。');
          return;
        }
        const tokenManager = (window as any).tokenManager;
        if (tokenManager && tokenManager.setToken) {
          tokenManager.setToken(res.Token, res.TokenExpiresAt, res.RefreshToken);
        }
        setToken(true)
        // if (res.url) {

        downloadStudy(studyUID);
        // }
      })
      .catch(res => {
        messageApi.error('验证失败，请稍后重试');
      });
  }, [inputCode, code, studyUID]);

  return (
    <>
      {contextHolder}
      <div className={styles.wrapper}>
        <div className={styles.accessCodeContainerPage}>
          <img
            src={hospital2Image}
            style={{ width: '40px', height: '40px' }}
            alt="医院图片"
            className={styles.hospitalImage}
          />
          <hr className={styles.divider} />
          <div className={styles.userInfo}>
            <img
              src={data?.sex === '女' ? bingrenNvImage : bingrenNanImage}
              style={{ width: '25px', height: '25px' }}
              alt="头像"
              className={styles.avatar}
            />
            <span className={styles.userName}>{data?.chinese_name}</span>
            <span className={styles.examType}>{data?.modality_code}</span>
          </div>
          <div className={styles.downloadSection}>
            <h3 className={styles.sectionTitle}>影像下载</h3>
            <Input
              ref={inputRef}
              key="download-input"
              placeholder="请输入提取码 不区分大小写"
              value={inputCode}
              onChange={handleCodeChange}
              className={styles.downloadInput}
            />
            <div className="flex-grow pl-1">
              {studyLoading && (
                <>
                  <Spin tip="Loading"></Spin>
                  <p className='mt-2'>正在下载，请等待下载完成...</p>
                </>
              )}
            </div>
            <Button
              type="primary"
              onClick={handleDownloadOK}
              className="h-[30px] w-full bg-[#5794f7]"
            >
              提取文件
            </Button>
            <p className={styles.downloadtips}>将于{expirationDate}失效</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default DownloadAccessCode;
